import api from '../../api/index.js'

const state = {
    
}

const getters = {

}

const actions = {
    CartList({commit},payload){
        return new Promise((resolve, reject) => {
            api.get('/Cart/List',payload, res => {
                resolve(res);
            }, err => {
                reject(err);
            })
        })
    },
    PostCart({commit},payload) {
        return new Promise((resolve, reject) => {
            api.post('/Cart/Post',payload, res => {
                resolve(res);
            }, err => {
                reject(err);
            })
        })
    },
    CartDelete({commit},payload) {
        return new Promise((resolve, reject) => {
            api.delete('/Cart/Delete',payload, res => {
                resolve(res);
            }, err => {
                reject(err);
            })
        })
    },
    CartCheck({commit},payload){
        return new Promise((resolve, reject) => {
            api.postNs('/Cart/Check',payload, res => {
                resolve(res);
            }, err => {
                reject(err);
            })
        })
    },
    CartUpdateNumber({commit},payload)
    {
        return new Promise((resolve, reject) => {
            api.postNs('/Cart/UpdateNumber',payload, res => {
                resolve(res);
            }, err => {
                reject(err);
            })
        })
    }
   
}

const mutations = {
    
}

export default {
    state,
    getters,
    actions,
    mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/cart.js